import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import EntrarParaAvaliar from "@/pages/EntrarParaAvaliar";

export const Route = createFileRoute("/entrar-para-avaliar")({
  head: () => seoHead({
    title: "Entrar para avaliar | Shopping do Bem",
    description: "Entre na sua conta para avaliar a loja.",
    path: "/entrar-para-avaliar",
    noindex: true,
  }),
  component: EntrarParaAvaliar,
});
